<template>
    <div class="dialog-sale-no-revenue">
        <span slot="title">
            <div class="snr-title">
              <div class="snr-title__text">
                  <hr>
                <div class="snr-title__sub mt-3 mb-3">
                    <span>Tổng: <b style="color: #409EFF">{{ listSaleNoRevenue.length }}</b></span>
                </div>
              </div>
            </div>
        </span>

        <div class="snr-toolbar">
            <el-row :gutter="12" class="mb-4">
                <el-col style="width: 250px"  :xs="24" :sm="8" v-if="[6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)">
                    <el-select
                        v-model="form.area_id"
                        placeholder="Khu vực"
                        filterable
                        clearable
                        class="w-100 mt-2"
                        @change="getCenter(); getListSaleNoRevenue();"
                    >
                        <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>

                <el-col style="width: 250px" :xs="24" :sm="8" v-if="[5, 6].includes(keyAccount)">
                    <el-select
                        v-model="form.branch_id"
                        placeholder="Văn phòng"
                        filterable
                        clearable
                        class="w-100 mt-2"
                        @change="getListSaleNoRevenue();"
                    >
                        <el-option
                            v-for="item in branches"
                            :key="item.id"
                            :label="item.name_alias || item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-col>

                <el-col style="width: 250px" :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="form.account_type_id" placeholder="Chọn chức vụ" clearable class="w-100 mt-2"  @change="getListSaleNoRevenue();">
                        <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col style="width: 250px" :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-date-picker
                        class="w-100 mt-2"
                        v-model="form.dataRange"
                        type="datetimerange"
                        start-placeholder="Từ ngày"
                        end-placeholder="đến ngày"
                        value-format="yyyy-MM-dd"
                        format="dd/MM/yyyy"
                        :default-time="['00:00:00', '23:59:59']"
                        @change="getListSaleNoRevenue"
                    />
                </el-col>
            </el-row>
        </div>
        <hr>

        <el-table
            v-if="!loadingSaleNoRevenue"
            :data="listSaleNoRevenue"
            border
            stripe
            size="mini"
            height="60vh"
            style="width: 100%;"
            empty-text="Không có dữ liệu"
        >
            <el-table-column label="Mã nhân sự" width="90">
                <template v-slot="scope">{{ scope.row.id + 100000 }}</template>
            </el-table-column>

            <el-table-column prop="name" label="Họ tên" min-width="150" />

            <el-table-column label="Chi nhánh" >
                <template v-slot="scope" style="word-break: break-word">
                    {{ scope.row.profile?.branch?.name_alias || scope.row.profile?.branch?.name || '—' }}
                </template>
            </el-table-column>

            <el-table-column label="Khu vực" width="100">
                <template v-slot="scope">
                    <el-tag size="mini" type="info" effect="plain">
                        {{ scope.row.profile?.area?.name || '—' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column width="200" label="Cấp trên">
                <template v-slot="scope">
                    <span v-if="scope.row.user_boss" style="word-break: break-word">
                      {{ scope.row.user_boss.id + 100000 }} - {{ scope.row.user_boss.name }}
                    </span>
                    <span v-else>—</span>
                </template>
            </el-table-column>

            <el-table-column prop="phone" label="SĐT" width="140" />
        </el-table>
        <div v-else class="text-center mb-5" style="height: 30vh;">
            <img src="../../../../assets/img/background/bg-loading.svg" alt="Coming Soon" style="max-width: 100%; max-height: 100%;">
            <div>
                <span><i class="el-icon-loading"></i> loading.....</span>
            </div>
        </div>

      <span slot="footer" class="snr-footer d-flex justify-content-end mt-3">
        <el-button @click="close()">Đóng</el-button>
      </span>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {GET_LIST_SALE_NO_REVENUE} from "../../../../core/services/store/user/users.module";
import {BRANCH_LIST, GET_CHILD_USER} from "../../../../core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "../../../../core/services/store/customer/customer.module";

export default {
    name: 'dialogSaleNoRevenue',
    props: {
        is_show: { type: Boolean, default: () => false },
    },
    data () {
        return {
            form: {
                area_id: '',
                branch_id: '',
                account_type_id: '',
                dataRange: [],
            },
            tableData: [],
            branches: [],
            areas: [],
            loadingSaleNoRevenue: false,
            listSaleNoRevenue: [],
            mechanisms: [
                { id: 1, name: 'Lương cứng' },
                { id: 2, name: 'Lương mềm' },
                { id: 3, name: 'Lương cứng theo bậc' },
                { id: 4, name: 'Lương cứng cố định' },
                { id: 5, name: 'Lương cứng partime' },
            ],

            positions: [
                { id: 1, name: 'Sales Leader' },
                { id: 2, name: 'Sales Expert' },
                { id: 3, name: 'Sales' },
                { id: 4, name: 'Sales Intern' },
                { id: 5, name: 'Giám đốc văn phòng' },
                { id: 6, name: 'Giám đốc khu vực' },
                { id: 26, name: 'Giám đốc vùng' },
            ],

            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4], // BOD
                6: [6, 5, 1, 2, 3, 4, 26], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6], // Giám đốc khu vực
                4: [1, 2, 3, 4, 5], // Giám đốc văn phòng
                3: [1, 2, 3, 4], // Sales Leader
            },
        }
    },
    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getListSaleNoRevenue();
                    this.getCenter();
                    this.getRegions();

                }
            },
        },
    },

    created() {
        this.setDefaultMonthRange();
    },

    methods: {
        async getListSaleNoRevenue() {
            this.loadingSaleNoRevenue = true
            try {
                const payload = {
                    area_id: this.form.area_id || '',
                    branch_id: this.form.branch_id || '',
                    account_type_id: this.form.account_type_id || '',
                    start_date: this.form.dataRange?.[0] || '',
                    end_date: this.form.dataRange?.[1] || '',
                }

                const res = await this.$store.dispatch(GET_LIST_SALE_NO_REVENUE, payload)
                this.listSaleNoRevenue = Array.isArray(res?.data) ? res.data : []
            } finally {
                this.loadingSaleNoRevenue = false
            }
        },


        getCenter () {
            const payload = { area_id: this.form.area_id }
            this.$store.dispatch(BRANCH_LIST, payload).then((response) => {
                 this.branches = response.data
            })
        },

        getRegions () {
            const payload = { all: this.keyAccount === 7 ? 1 : 0 }
            this.$store.dispatch(GET_REGIONS_BY_USER, payload).then((response) => {
                 this.areas = response.data
            })
        },

        setDefaultMonthRange() {
            this.form.dataRange = [
                this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
            ];
        },

        close() {
            this.$emit('close')
        }
    },
    computed: {
        ...mapGetters(["currentUser", "keyAccount"]),
        filteredPositions () {
            if (!this.keyAccount) return this.positions
            const ids = this.keyAccountMap[this.keyAccount] || []
            return this.positions.filter(p => ids.includes(p.id))
        },
    },
}

</script>
